module.exports = __webpack_public_path__ + "assets/img/default_head.3aed5dd9.png";